import api from '@/api-client';
import EventBus from '@/event-bus';

export default {
    async fetch({ commit }, id) {
        const { data: incident } = await api.get(`incidents/${id}`);
        commit('setIncident', incident);
        EventBus.$emit('new-content-loaded')
        return incident
    }
}
